import React from 'react';
import { Popover, IPopoverProps } from '../popover/index';

export interface PopoverScrollableProps extends IPopoverProps {
	/** @default true */
	scrollable?: boolean;
	header?: React.ReactNode;
	footer?: React.ReactNode;
	/** @default 50vh */
	scrollableHeight?: string;
}

/* A scrollable version of Popover with cutomisable header and footer sections that are fixed */
export function PopoverScrollable(props: PopoverScrollableProps) {
	const { scrollable = true, header, footer, scrollableHeight, ...otherProps } = props;

	const scrollableStyle: React.CSSProperties = {
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		flexWrap: 'nowrap',
		maxHeight: scrollableHeight ?? '50vh'
	};

	return (
		<Popover
			{...otherProps}
			overlay={
				<>
					{header && header}
					<div style={scrollable ? scrollableStyle : {}}>{typeof props.overlay === 'function' ? props.overlay() : props.overlay}</div>
					{footer && footer}
				</>
			}
		></Popover>
	);
}
